import { Guid } from "@/types"
import Notification, { IGetNotification } from "./Notification"

export interface IGetNotificationShippingOrderRejectedDto extends IGetNotification {
    reservationId: Guid
    reservationNumber: string
    comment: string
}

export default class NotificationShippingOrderRejected extends Notification {
    reservationId: Guid
    reservationNumber: string
    comment: string

    constructor(dto: IGetNotificationShippingOrderRejectedDto) {
        super(dto)
        this.reservationId = dto.reservationId
        this.reservationNumber = dto.reservationNumber
        this.comment = dto.comment
    }
}
